import i18next from 'i18next';
import React from 'react';
import { toast } from 'react-toastify';

import styles from './styles.module.scss';

const LOGIN_SUCCESS_TOAST = 'claveunica-login-success';

// Confirms the ClaveÚnica login on top of the next screen (the global
// ToastContainer survives the route change). The id avoids duplicates.
export const showLoginSuccessToast = () =>
  toast.success(
    <div className={styles.toast}>
      <strong>{i18next.t('ClientUniqueKeyLogin:loginSuccessTitle')}</strong>
      <span>{i18next.t('ClientUniqueKeyLogin:loginSuccessDetail')}</span>
    </div>,
    { toastId: LOGIN_SUCCESS_TOAST }
  );
